import React from "react";
import "./ECLDatePicker.css";
import { dateToDateLocal } from "./DateHelpers";

//Props
// date - string optional - Initial date value
// id - string required - used to set the input's id, necessary for form submission
// name - string option - if included, creates a label for input element
// min - a string that has the minimum date
// max - a string that has the maximum date
// required - boolean optional
// onChange - function that calls when the input value changes

export default function ECLDatePicker(props) {
   //Ensures that we pass the date set to local day on client
   return (
      <>
         {props.name && (
            <label htmlFor={props.id || "date-picker"}>
               {props.name}
               {props.required && <span className="required-input">*</span>}
            </label>
         )}
         <input
            type="date"
            id={props.id}
            // Display min/max dates without restricting calendar
            defaultValue={
               props.date ? dateToDateLocal(props.date) : dateToDateLocal()
            }
            min={props.min && dateToDateLocal(props.min)}
            max={props.max && dateToDateLocal(props.max)}
            required={props.required}
            onChange={props.onChange}
            tabIndex={props.tabIndex}
         />
      </>
   );
}
